import React from 'react';
import _ from 'lodash';

import PositionedGoodyHOC from '../PositionedGoodyHOC';
import { POSITIONED_GOODY_REFS } from '../../../../constants';

class Cat extends PositionedGoodyHOC {
	// 9
	render() {
		const style = {
			st2: {
				fill: '#FFFFFF',
			},
			st82: {
				fill: '#EBEFFF',
			},
		};
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} cx="12.036643" cy="84.0755081" />
				<path style={style.st2} d="M17.1588974,8.9754705c0.541687,2.625,0.8620644,8.4152346,0.8620644,8.4152346l1.1979485,3.4234982
					c1.2046223,3.4425716,1.6372013,7.1079922,1.2670708,10.7364101l-0.3622875,3.5515289l1.6860237,5.2146721
					c0.9740334,3.0125694,1.3637867,6.1834335,1.1483173,9.3422127l-0.4036255,5.9171638l2.0243626,6.6664734
					c0.8333969,2.7444725,1.1856918,5.6124458,1.0413017,8.4770317l-0.3778477,7.4961319
					c0,0,3.0833378,13.4636917-11.3654051,13.4636917c-14.5512571,0-14.7179241-15.4540482-12.4716015-23.7567749l1.3895756-4.1880684
					l-0.4142787-4.1677628c-0.3281109-3.3008881,0.0075343-6.6340599,0.9871721-9.8032608l1.7628253-5.7028656l-0.3290553-2.5133247
					c-0.4740615-3.6208763-0.1447968-7.3017273,0.9643955-10.7809772l1.5025201-4.7130184l-0.000001-0.0000057
					c-0.7923408-4.3564873-0.4070277-8.8455276,1.1161237-13.0032654l0.6326847-1.7270355l0.2892637-2.4364853
					c0.2297735-1.9353929,1.1488333-8.5661983,3.7506428-8.5661983S16.6172104,6.3504705,17.1588974,8.9754705z" />
				<path style={style.st82} d="M20.928978,79.6029129c1.2446289,0,2.5566406-0.125,3.9345703-0.3964844l0.5263672-0.1035156
					c-0.0720215-0.5567627-0.147644-0.887085-0.147644-0.887085l0.0571289-1.1334229l-0.8225708,0.1621094
					c-6.4433594,1.2666016-12.015625-0.8017578-16.5683594-6.1523438c-3.4741211-4.0834961-5.0244141-8.6381836-5.0400391-8.6835938
					l-0.2921753-0.8724365l0.2185669,2.1986084l-0.6663818,2.0083008
					C4.4201274,70.4376297,10.2614365,79.6043777,20.928978,79.6029129z" />
				<path style={style.st82} d="M22.5544052,55.5761795l0.0799561-1.1719971l-0.9075317,0.1787109
					c-4.9360352,0.9731445-9.2143555-0.6147461-12.7084961-4.7167969c-2.6870122-3.1538086-3.8881841-6.6772461-3.8999028-6.7128906
					l-0.1749878-0.5211182l0.1870728,1.4287109l-0.7345581,2.3763428c1.9710083,3.8208008,6.5421147,10.4224854,14.5994263,10.4221191
					c0.9863281,0,2.0253906-0.0991211,3.1181641-0.3144531l0.6936035-0.1363525L22.5544052,55.5761795z" />
				<path style={style.st82} d="M19.8635483,36.049202l0.5324707-0.1047363l-0.2723389-0.8422852l0.1188965-1.1657715
					l-0.7657471,0.1508789C10.859642,35.780159,7.5066142,26.1346493,7.3684306,25.7235165l-0.2651978-0.7888184
					c0.0504761,0.3734131,0.0975342,0.7470703,0.1651611,1.1187744L6.4672465,28.566534
					c1.551209,2.927002,5.0082402,7.7238789,11.0130005,7.7229023C18.2336655,36.2894363,19.0285873,36.2137527,19.8635483,36.049202z
					" />
				<path style={style.st82} d="M18.3619614,18.3653622l-0.3410034-0.9746094c0,0-0.0218506-0.3922119-0.0629883-1.012085
					c-6.0838623,0.4388428-8.4960938-6.4726553-8.6008301-6.7835684L9.2574692,9.2994452l-0.2402954,2.0236816l-0.47052,1.2844238
					c1.5922852,2.7766113,4.5301514,5.8057852,8.8641968,5.805419C17.720726,18.4129696,18.0378036,18.3974667,18.3619614,18.3653622z
					" />
			</g>
		);
	}
}

class Tortoise extends PositionedGoodyHOC {
	// 9
	render() {
		const style = {
			st2: {
				fill: '#FFFFFF',
			},
			st82: {
				fill: '#EBEFFF',
			},
		};
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} cx="15.036643" cy="87.0755081" />
				<path style={style.st2} d="M17.1588974,8.9754705c0.541687,2.625,0.8620644,8.4152346,0.8620644,8.4152346l1.1979485,3.4234982
					c1.2046223,3.4425716,1.6372013,7.1079922,1.2670708,10.7364101l-0.3622875,3.5515289l1.6860237,5.2146721
					c0.9740334,3.0125694,1.3637867,6.1834335,1.1483173,9.3422127l-0.4036255,5.9171638l2.0243626,6.6664734
					c0.8333969,2.7444725,1.1856918,5.6124458,1.0413017,8.4770317l-0.3778477,7.4961319
					c0,0,3.0833378,13.4636917-11.3654051,13.4636917c-14.5512571,0-14.7179241-15.4540482-12.4716015-23.7567749l1.3895756-4.1880684
					l-0.4142787-4.1677628c-0.3281109-3.3008881,0.0075343-6.6340599,0.9871721-9.8032608l1.7628253-5.7028656l-0.3290553-2.5133247
					c-0.4740615-3.6208763-0.1447968-7.3017273,0.9643955-10.7809772l1.5025201-4.7130184l-0.000001-0.0000057
					c-0.7923408-4.3564873-0.4070277-8.8455276,1.1161237-13.0032654l0.6326847-1.7270355l0.2892637-2.4364853
					c0.2297735-1.9353929,1.1488333-8.5661983,3.7506428-8.5661983S16.6172104,6.3504705,17.1588974,8.9754705z" />
				<path style={style.st82} d="M20.928978,79.6029129c1.2446289,0,2.5566406-0.125,3.9345703-0.3964844l0.5263672-0.1035156
					c-0.0720215-0.5567627-0.147644-0.887085-0.147644-0.887085l0.0571289-1.1334229l-0.8225708,0.1621094
					c-6.4433594,1.2666016-12.015625-0.8017578-16.5683594-6.1523438c-3.4741211-4.0834961-5.0244141-8.6381836-5.0400391-8.6835938
					l-0.2921753-0.8724365l0.2185669,2.1986084l-0.6663818,2.0083008
					C4.4201274,70.4376297,10.2614365,79.6043777,20.928978,79.6029129z" />
				<path style={style.st82} d="M22.5544052,55.5761795l0.0799561-1.1719971l-0.9075317,0.1787109
					c-4.9360352,0.9731445-9.2143555-0.6147461-12.7084961-4.7167969c-2.6870122-3.1538086-3.8881841-6.6772461-3.8999028-6.7128906
					l-0.1749878-0.5211182l0.1870728,1.4287109l-0.7345581,2.3763428c1.9710083,3.8208008,6.5421147,10.4224854,14.5994263,10.4221191
					c0.9863281,0,2.0253906-0.0991211,3.1181641-0.3144531l0.6936035-0.1363525L22.5544052,55.5761795z" />
				<path style={style.st82} d="M19.8635483,36.049202l0.5324707-0.1047363l-0.2723389-0.8422852l0.1188965-1.1657715
					l-0.7657471,0.1508789C10.859642,35.780159,7.5066142,26.1346493,7.3684306,25.7235165l-0.2651978-0.7888184
					c0.0504761,0.3734131,0.0975342,0.7470703,0.1651611,1.1187744L6.4672465,28.566534
					c1.551209,2.927002,5.0082402,7.7238789,11.0130005,7.7229023C18.2336655,36.2894363,19.0285873,36.2137527,19.8635483,36.049202z
					" />
				<path style={style.st82} d="M18.3619614,18.3653622l-0.3410034-0.9746094c0,0-0.0218506-0.3922119-0.0629883-1.012085
					c-6.0838623,0.4388428-8.4960938-6.4726553-8.6008301-6.7835684L9.2574692,9.2994452l-0.2402954,2.0236816l-0.47052,1.2844238
					c1.5922852,2.7766113,4.5301514,5.8057852,8.8641968,5.805419C17.720726,18.4129696,18.0378036,18.3974667,18.3619614,18.3653622z
					" />
			</g>
		);
	}
}

class Pig extends PositionedGoodyHOC {
	// 9
	render() {
		const style = {
			st2: {
				fill: '#FFFFFF',
			},
			st82: {
				fill: '#EBEFFF',
			},
		};
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} cx="18.036643" cy="84.0755081" />
				<path style={style.st2} d="M17.1588974,8.9754705c0.541687,2.625,0.8620644,8.4152346,0.8620644,8.4152346l1.1979485,3.4234982
					c1.2046223,3.4425716,1.6372013,7.1079922,1.2670708,10.7364101l-0.3622875,3.5515289l1.6860237,5.2146721
					c0.9740334,3.0125694,1.3637867,6.1834335,1.1483173,9.3422127l-0.4036255,5.9171638l2.0243626,6.6664734
					c0.8333969,2.7444725,1.1856918,5.6124458,1.0413017,8.4770317l-0.3778477,7.4961319
					c0,0,3.0833378,13.4636917-11.3654051,13.4636917c-14.5512571,0-14.7179241-15.4540482-12.4716015-23.7567749l1.3895756-4.1880684
					l-0.4142787-4.1677628c-0.3281109-3.3008881,0.0075343-6.6340599,0.9871721-9.8032608l1.7628253-5.7028656l-0.3290553-2.5133247
					c-0.4740615-3.6208763-0.1447968-7.3017273,0.9643955-10.7809772l1.5025201-4.7130184l-0.000001-0.0000057
					c-0.7923408-4.3564873-0.4070277-8.8455276,1.1161237-13.0032654l0.6326847-1.7270355l0.2892637-2.4364853
					c0.2297735-1.9353929,1.1488333-8.5661983,3.7506428-8.5661983S16.6172104,6.3504705,17.1588974,8.9754705z" />
				<path style={style.st82} d="M20.928978,79.6029129c1.2446289,0,2.5566406-0.125,3.9345703-0.3964844l0.5263672-0.1035156
					c-0.0720215-0.5567627-0.147644-0.887085-0.147644-0.887085l0.0571289-1.1334229l-0.8225708,0.1621094
					c-6.4433594,1.2666016-12.015625-0.8017578-16.5683594-6.1523438c-3.4741211-4.0834961-5.0244141-8.6381836-5.0400391-8.6835938
					l-0.2921753-0.8724365l0.2185669,2.1986084l-0.6663818,2.0083008
					C4.4201274,70.4376297,10.2614365,79.6043777,20.928978,79.6029129z" />
				<path style={style.st82} d="M22.5544052,55.5761795l0.0799561-1.1719971l-0.9075317,0.1787109
					c-4.9360352,0.9731445-9.2143555-0.6147461-12.7084961-4.7167969c-2.6870122-3.1538086-3.8881841-6.6772461-3.8999028-6.7128906
					l-0.1749878-0.5211182l0.1870728,1.4287109l-0.7345581,2.3763428c1.9710083,3.8208008,6.5421147,10.4224854,14.5994263,10.4221191
					c0.9863281,0,2.0253906-0.0991211,3.1181641-0.3144531l0.6936035-0.1363525L22.5544052,55.5761795z" />
				<path style={style.st82} d="M19.8635483,36.049202l0.5324707-0.1047363l-0.2723389-0.8422852l0.1188965-1.1657715
					l-0.7657471,0.1508789C10.859642,35.780159,7.5066142,26.1346493,7.3684306,25.7235165l-0.2651978-0.7888184
					c0.0504761,0.3734131,0.0975342,0.7470703,0.1651611,1.1187744L6.4672465,28.566534
					c1.551209,2.927002,5.0082402,7.7238789,11.0130005,7.7229023C18.2336655,36.2894363,19.0285873,36.2137527,19.8635483,36.049202z
					" />
				<path style={style.st82} d="M18.3619614,18.3653622l-0.3410034-0.9746094c0,0-0.0218506-0.3922119-0.0629883-1.012085
					c-6.0838623,0.4388428-8.4960938-6.4726553-8.6008301-6.7835684L9.2574692,9.2994452l-0.2402954,2.0236816l-0.47052,1.2844238
					c1.5922852,2.7766113,4.5301514,5.8057852,8.8641968,5.805419C17.720726,18.4129696,18.0378036,18.3974667,18.3619614,18.3653622z
					" />
			</g>
		);
	}
}

function Unicorn(props) {
	const unicorns = {
		Cat,
		Tortoise,
		Pig,
	};

	const ThisUnicorn = unicorns[props.petType.name] || Cat;

	if (_.isUndefined(ThisUnicorn)) {
		return null;
	}

	return <ThisUnicorn {...props} />;
}

export default Unicorn;



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Hat/Unicorn.js